import type { curator, operation } from "@repo/client";

/**
 * Extract the asset data from a collection assets response.
 */
export const parseAssetsListResponse = (response: operation.Response<curator.CollectionAssets> | undefined) =>
  response?.data.result.entities.map((a) => a.data) || [];
